export default __webpack_public_path__ + "static/media/HarshPatodia.cf8a09a5.png";